<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <!-- end row -->
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card">
            <div class="card-body">
              <div class="p-2">
                <div class="text-center">
                  <div class="avatar-md mx-auto">
                    <div class="avatar-title rounded-circle bg-light">
                      <i class="bx bx-briefcase-alt-2 h1 mb-0 text-primary"></i>
                    </div>
                  </div>
                  <div class="p-2 mt-4">
                    <h4>{{ $t('utility.payment_completed') }}!</h4>
                    <p class="text-muted">
                      {{ $t('utility.payment_successful') }}
                    </p>
                    <div class="mt-4">
                      <router-link to="/" class="btn btn-success">{{
                        $t('utility.continue')
                      }}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from '@/app.config'

/**
 * Confirm-mail component
 */
export default {
  page: {
    title: 'payment',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {},
  data() {
    return {}
  },
  created() {
    this.$_loading()
  },
  methods: {},
}
</script>
